<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-toolbar-title>Customer Log Type Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              :options.sync="pagination"
              :loading="loading"
              item-key="name"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row">
                <tr>
                  <td class="text-xs-left">{{ row.item.logType }}</td>
                  <td class="text-xs-left">{{ row.item.logTypeDesc }}</td>
                  <td class="text-xs-center">
                    <v-btn icon color="primary" text type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      headers: [
        { text: 'Log Type', value: 'logType' },
        { text: 'Description', value: 'logTypeDesc' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      loading: true,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit() {
      const apiUrl = this.$store.state.underwriting.customerLogSettings.menu.custLogTypeUWList
      if (apiUrl) {
        this.loading = true
        this.$http
          .get(expandURI(apiUrl))
          .then((result) => {
            const { data } = result.data
            if (data) {
              this.items = []
              data[0].custLogType.map((datamap) => {
                const custLogTypeList = {
                  logType: datamap.logType,
                  logTypeDesc: datamap.logTypeDesc
                }
                this.items.push(custLogTypeList)
              })
              this.loading = false
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.loading = false
              this.message(data)
              this.fieldMessage(data)
            }
          })
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doSelect(data) {
      const value = {
        logType: data.logType,
        logTypeDesc: data.logTypeDesc
      }
      this.$emit('selectCustLogType', value)
      this.$emit('close')
    }
  },
  computed: {
    menu() {
      return this.$store.state.underwriting.policyRiskItemSettings.menu
    }
  },
  mixins: [TableConst.default, MessageMixin],
  props: {
    busClass: {
      type: String,
      default: ''
    },
    riskTxtRef: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
</style>
